var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('div',{staticClass:"floating-component"},[_c('I18n')],1),_c('a',{attrs:{"href":"https://www.tokenpocket.pro/?from=scatter-demo-eosjs2"}}),_c('img',{staticStyle:{"height":"30px"},attrs:{"alt":"znl logo","src":require("../assets/ic_launcher_round.png")}}),_c('h1',[_vm._v("ZNL智能支付")]),_c('TransferPayment')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }